export const UPDATE_ACCESS = "update-access";
export const DASHBOARD_FOLDER = "dashboard-folders";
export const UPDATE_ACCESS_WITH_NO_GROUP = "update-access-with-no-groups";
export const AUTHORIZED_TO_GROUPS = "authorized-to-groups";
export const UNATHORIZED_TO_GROUPS = "unauthorized-to-groups";
export const DASHBOARD_PROJ_MEMBER_LIST = "dashboard-project-member-list";
export const LOCAL_STORAGE_KEY = "usercreds";
export const LOCAL_ISADMIN = "isadmin";
